/* eslint-disable no-extra-parens */

WB.Popups = WB.Popups || {};
WB.Popups.BaseDirectiveLink = function(
    $timeout,
    $window,
    PathHelper,
    RoutingHistory,
    GlobalClassUtility,
    $location
) {
    return function(scope, element, attr) {
        scope.closed = true;

        var onPendingRouteChange = function(newPendingRoute) {
            if (
                !newPendingRoute
				|| (newPendingRoute.resolve && !newPendingRoute.resolve.popup)
            ) {
                return;
            }
            GlobalClassUtility.toggleClass(
                'is-popup-open',
                newPendingRoute.resolve.popup
            );
            if (!newPendingRoute.isComingFromPopup) {
                $timeout(function() {
                    $window.scrollTo(0, 0);
                });
            }
        };
        scope.$watch(function() {
            return scope.$root.PendingRoute;
        }, onPendingRouteChange);

        scope.close = function() {
            var previousStandardRoute = RoutingHistory.getPreviousStandardRoute();
            var pathName = !previousStandardRoute
                ? 'forecasts'
                : previousStandardRoute.locals.name;
            var previousScroll = scope.$root.previousScrollPosition;

            $location.url(PathHelper.pathForName(pathName));

            $timeout(function() {
                if (previousScroll) {
                    $window.scrollTo(0, previousScroll);
                }
            });
        };
    };
};

WB.Popups.BaseDirectiveController = function($scope, $window, $timeout) {
    this.open = function(popup) {};

    this.destroy = function() {};
};
WB.Popups.BaseDirectiveController.$inject = ['$scope', '$window', '$timeout'];

WB.Popups.BaseDirective = function(
    $timeout,
    $window,
    PathHelper,
    RoutingHistory,
    GlobalClassUtility,
    $location
) {
    return {
        scope: {},
        restrict: 'AE',
        link: WB.Popups.BaseDirectiveLink(
            $timeout,
            $window,
            PathHelper,
            RoutingHistory,
            GlobalClassUtility,
            $location
        ),
        controller: WB.Popups.BaseDirectiveController,
        template: `<div ng-if="$root.ActiveRoute.locals.popup === 'Video'">
        <national-outlook-screen />
    </div>
    <div ng-if="$root.ActiveRoute.locals.popup === 'Story'">
        <div wb-popup-story></div>
    </div>
    <div ng-if="$root.RouteLoader === 'Popup'" ng-cloak>
        <div class="module-loader block-loader is-clear"
            wb-preloader color="white">
        </div>
    </div>`
    };
};
WB.Popups.BaseDirective.$inject = [
    '$timeout',
    '$window',
    'PathHelper',
    'RoutingHistory',
    'GlobalClassUtility',
    '$location'
];

WB.App.directive('wbPopupBase', WB.Popups.BaseDirective);
